import { render, staticRenderFns } from "./CountryDescription.vue?vue&type=template&id=2434ff8a&"
import script from "./CountryDescription.vue?vue&type=script&lang=js&"
export * from "./CountryDescription.vue?vue&type=script&lang=js&"
import style0 from "./CountryDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports